import dynamic from 'next/dynamic'
import { useState } from 'react'
import Menu from 'components/menu/menu'
// import Panel from 'components/panel/panel'
import { cn } from 'utils/helpers'
import Link from 'next/link'
import Svg from 'components/svg/svg'
import Icon from 'components/icon/icon'
import Backdrop from 'components/backdrop/backdrop'
import styles from './splitted.module.scss'
import headerStyles from 'components/header/header.module.scss'

const HeaderIcons = dynamic(() => import('components/header-icons/header-icons'))

export default function Splitted({ children, items, title, input }) {
    const [mobileShow, setMobileShow] = useState()

    const hideMenuHandler = () => {
        setMobileShow(false)
    }

    const showMenuHandler = () => {
        setMobileShow(true)
    }

    return (
        <>
            <div className={styles.header}>
                <Backdrop className={mobileShow && styles.backdropShow} onClick={hideMenuHandler} />
                <div className={cn(styles.headerLeft)}>
                    {items && !!items.length && (
                        <Icon icon="menu" onClick={showMenuHandler} className={styles.menuIcon} btn />
                    )}
                    <div className={styles.menuName}>{title}</div>
                </div>
                <Link href="/">
                    <a className={cn(headerStyles.logo, styles.logo)}>
                        <Svg name="logo" />
                    </a>
                </Link>
                <div className={styles.headerRight}>
                    {input}
                    <Link href="/">
                        <a className={styles.symbol}>
                            <Svg name="home" />
                        </a>
                    </Link>
                    <HeaderIcons hideDropdown />
                </div>
            </div>
            <div className={styles.full}>
                <div className={styles.wrap}>
                    <div className={styles.splitted}>
                        {items && (
                            <div className={cn(styles.left, mobileShow && styles.mobileShow)}>
                                <Icon icon="x" btn className={styles.closeFilterBtn} onClick={hideMenuHandler} />
                                <Menu items={items} />
                            </div>
                        )}
                        <div className={styles.right}>{children}</div>
                    </div>
                </div>
            </div>
        </>
    )
}
// <Panel desktop>{children}</Panel>
